"use client";
import * as React from "react";
const SvgHelpRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm.8 12.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm1.656-5.4-.72.736c-.4.408-.688.776-.832 1.352a3.67 3.67 0 0 0-.104.912H7.2V10a3.198 3.198 0 0 1 .936-2.264l.992-1.008c.368-.352.544-.88.44-1.44a1.593 1.593 0 0 0-1.112-1.224A1.613 1.613 0 0 0 6.48 5.08c-.096.296-.344.52-.656.52h-.24a.693.693 0 0 1-.656-.896A3.206 3.206 0 0 1 7.512 2.44c1.216-.192 2.376.44 3.096 1.44.944 1.304.664 2.704-.152 3.52Z" }));
export {
  SvgHelpRound as default
};
